import { useMemo } from 'react'
import { RenderableTextField } from '../store/types'
import { useSchemeText } from './useSchemeText'
import { usePersonalizationConfig } from '../../Experience/hooks/usePersonalizationConfig'

interface UseSchemeTextFieldsResult {
  templateTextFields: RenderableTextField[]
}

export const useSchemeTemplateText = (schemeId: string): UseSchemeTextFieldsResult => {
  const { text } = useSchemeText(schemeId)
  const { templateFields } = usePersonalizationConfig()

  const templateTextFields: RenderableTextField[] = useMemo(
    () =>
      templateFields.map((field) => {
        const match = text.find((t) => t.textField.purposeName === field.purposeName)

        return {
          ...field,
          text: match?.textField.text ?? '',
        }
      }),
    [templateFields, text],
  )

  return {
    templateTextFields,
  }
}
